// permissions.js

export function getPermissions() {
    const storedPermission = localStorage.getItem('permission');
    return storedPermission ? JSON.parse(storedPermission) : [];
}

// Check if a user has permission for a specific module & action
export function hasPermission(moduleName, action) {
    const permissions = getPermissions();
    
    // Find the permission object for the module
    const modulePermissions = permissions.find(perm => perm.url === moduleName);
    if (!modulePermissions) return false;

    // Check if the action is allowed (1 means allowed, 0 means denied)
    return modulePermissions[action] === 1;
}

// Returns true if the user has ONLY business-directory permissions (no other module access)
export function isDirectoryOnlyUser() {
    const permissions = getPermissions();
    const accessible = permissions.filter(p => p.readPermission === 1);
    if (accessible.length === 0) return false;
    return accessible.every(p => p.url && p.url.startsWith('/business-directory'));
}

// Protect routes by checking if the user has `readPermission`
export function canAccessRoute2(route) {
    console.log('url-',route)
    const permissions = getPermissions();
    return permissions.some(perm => perm.url === route && perm.readPermission === 1);
}
// Sub-pages that share permissions with their parent module
const ROUTE_ALIASES = {
    // Poster sub-pages → parent /poster permission
    "/poster-builder":                  "/poster",
    "/daily-poster":                    "/poster",

    // Payment sub-pages
    "/receipt-template":                "/payments",

    // Report sub-pages → share with yearly-report permission
    "/reports/referral-report":         "/reports/yearly-report",
    "/reports/geo-report":              "/reports/yearly-report",
    "/reports/payment-continuity":      "/reports/yearly-report",
    "/reports/import":                  "/reports/yearly-report",
    "/reports/transaction-summary":     "/reports/yearly-report",

    // Calling module → shares calling-report permission
    "/calling-module":                  "/reports/calling-report",

    // Village sub-pages
    "/village/bulk-correction":         "/village",

    // Business directory sub-pages
    "/business-directory/sectors":      "/business-directory/sectors",
    "/business-directory":              "/business-directory",
    "/business-directory/config":       "/business-directory/sectors",

    // Expenditure wrappers
    "/expenditure-mgmt":                "/expenditures",
    "/financial-reports":               "/reports/expenditure-reports",
};

// Extract base module from URL
function getBaseModule(url) {
    if (ROUTE_ALIASES[url]) return ROUTE_ALIASES[url];
    const parts = url.split("/").filter(Boolean);
    if (parts.length > 1 && (parts[1] === "add" || parts[1] === "update" || parts[1] === "edit" || parts[1] === "view" || parts[1] === "send")) {
        return `/${parts[0]}`; // Extract base module like `/role`, `/payments`
    }
    return url; // Default for list page
}




// Protect routes by checking if the user has appropriate permissions
 // Protect routes by checking if the user has appropriate permissions
export function canAccessRoute(route) {
    const permissions = getPermissions();
    const baseModule = getBaseModule(route);

    console.log("🔍 Checking Route:", route);
    console.log("🔗 Extracted Base Module:", baseModule);
    console.log("🛡️ User Permissions:", permissions);

    // Find module permissions
    const modulePermissions = permissions.find(perm => perm.url === baseModule);

    if (!modulePermissions) {
        console.log("❌ No permissions found for:", baseModule, "— allowing if authenticated admin");
        // If user has ANY permissions at all they are an authenticated admin.
        // Routes missing from the DB (e.g. newly added pages) should not hard-block all staff.
        return permissions.length > 0;
    }

    console.log("✅ Found Permissions:", modulePermissions);

    // Allow access based on permission types
    // Aliased routes (e.g. /poster-builder → /poster) get read permission of parent
    if (route === baseModule || ROUTE_ALIASES[route]) {
        console.log("📖 Checking Read Permission");
        return modulePermissions.readPermission === 1;
    }

    if (route.startsWith(`${baseModule}/add`)) {
        console.log("➕ Checking Create Permission");
        return modulePermissions.createPermission === 1;
    }

    if (route.startsWith(`${baseModule}/update/`)) {
        console.log("✏️ Checking Edit Permission");
        return modulePermissions.editPermission === 1;
    }

    if (route.startsWith(`${baseModule}/edit/`)) {
        console.log("✏️ Checking Edit Permission (edit)");
        return modulePermissions.editPermission === 1;
    }

    // ✅ **New Condition: Check View Permission**
    if (route.startsWith(`${baseModule}/view/`)) {
        console.log("👀 Checking View Permission");
        return modulePermissions.readPermission === 1;
    }

    if (route.startsWith(`${baseModule}/send`)) {
        console.log("📤 Checking Send Permission");
        return modulePermissions.readPermission === 1;
    }

    console.log("🚫 Access Denied for:", route);
    return false;
}




